export default {"src":"/_next/static/media/oysters.ce43a08d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};